/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography2 } from '@coursera/cds-core';

import CoursePreviewLink from 'bundles/enroll-common/components/freemium/CoursePreviewLink';
import DottedSeparator from 'bundles/unified-description-page-common/components/shared/DottedSeparator';
import { durationToHours } from 'bundles/unified-description-page-common/utils/learningTime';

import _t from 'i18n!nls/xdp';

export type ModuleItemSubtitleElement = React.ReactElement<Props, typeof ModuleItemSubtitle>;

const styles = {
  container: css`
    display: flex;
    margin-top: var(--cds-spacing-50);
    flex-wrap: wrap;
  `,
};

type Props = {
  totalContentDuration?: string | null;
  moduleLabel?: string;
  showPreviewLink?: boolean;
  courseId?: string;
  courseSlug?: string;
};

const ModuleItemSubtitle = ({ totalContentDuration, moduleLabel, showPreviewLink, courseId, courseSlug }: Props) => {
  const showDuration = !!totalContentDuration;
  const showLabel = moduleLabel && moduleLabel.length > 0;
  const hasContent = showLabel || showDuration;

  if (!hasContent) {
    return null;
  }

  const labelContent = showLabel ? moduleLabel : null;

  return (
    <Typography2 variant="bodySecondary" color="supportText" component="div" css={styles.container}>
      {labelContent}
      {showDuration && (
        <React.Fragment>
          {showLabel && <DottedSeparator />}
          <FormattedMessage
            message={_t('{learningTime} to complete')}
            learningTime={durationToHours(totalContentDuration)}
          />
        </React.Fragment>
      )}
      {showPreviewLink && courseId && (
        <React.Fragment>
          <DottedSeparator />
          <CoursePreviewLink
            courseId={courseId}
            courseSlug={courseSlug}
            shouldStopPropagation={true}
            trackingName="xdp_syllabus_section_freemium_preview_course_link"
          />
        </React.Fragment>
      )}
    </Typography2>
  );
};

export default ModuleItemSubtitle;
